<template>
  <v-expansion-panel-content>
    <template v-slot:header>
      <h6 class="title">
        <v-icon
          class="mr-2"
        >
          handyman
        </v-icon>
        Custom Fields
        ({{ customFields ? customFields.length || 0 : 0 }})
      </h6>
      <div>
        <v-btn
          style="float: right;"
          dark
          :color="colorTheme"
          @click.stop="openAddCustomFieldModal"
        >
          <v-icon dark>
            add
          </v-icon>Add
        </v-btn>
        <v-btn
          style="float: right;"
          dark
          :color="colorTheme"
          @click.stop="addYieldTokenFields"
        >
          <v-icon dark>
            add
          </v-icon>Yield Token
        </v-btn>
        <v-btn
          style="float: right;"
          dark
          :color="colorTheme"
          @click.stop="addFinancingTokenFields"
        >
          <v-icon dark>
            add
          </v-icon>Financing Token
        </v-btn>
        <v-btn
          v-if="!deleteMode"
          style="float: right;"
          dark
          color="red"
          @click.stop="setDeleteMode(true)"
        >
          <v-icon dark>
            delete
          </v-icon>delete
        </v-btn>
        <v-btn
          v-if="deleteMode"
          style="float: right;"
          dark
          color="warning"
          @click.stop="setDeleteMode(false)"
        >
          <v-icon dark>
            cancel
          </v-icon>cancel
        </v-btn>
        <v-btn
          v-if="deleteMode"
          style="float: right;"
          dark
          color="red"
          @click.stop="deleteSelectedFields"
        >
          <v-icon dark>
            delete_outline
          </v-icon>delete
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-container
        fluid
        grid-list-sm
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            v-for="(customField, index) in customFields"
            :key="customField.name"
            xs6
            sm4
          >
            <v-checkbox
              v-if="deleteMode"
              :input-value="customField.selected"
              color="primary"
              hide-details
              @click.stop="toggleSelected(customField)"
            />
            <custom-field
              :index="index"
              :color-theme="colorTheme"
              :type="customField.type"
              :value="customField.value"
              :label="customField.name"
              :disabled="isFieldDisabled(customField)"
              :on-change="changeFunction"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <add-custom-field
      :dialog="isOpenAddCustomField"
      :color-theme="colorTheme"
      :submit-action="addCustomField"
      :cancel-action="closeCustomFieldModal"
    />
  </v-expansion-panel-content>
</template>

<script>
import CustomField from './shared/CustomField';
import AddCustomField from './AddCustomField';
import { FinancialInstrumentsEnum } from '@/enum/financialProducts/FinancialInstruments';

export default {
  name: 'CustomFieldsExpansionPanel',
  components: {
    CustomField,
    AddCustomField,
  },
  props: {
    customFields: {
      type: Array,
      default: () => [],
    },
    colorTheme: {
      type: String,
      default: 'blue',
    },
    addFunction: {
      type: Function,
      required: true,
    },
    changeFunction: {
      type: Function,
      required: true,
    },
    deleteFunction: {
      type: Function,
      required: true,
    },
    instrument: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isOpenAddCustomField: false,
      deleteMode: false,
    };
  },
  mounted() {
    if (this.instrument === FinancialInstrumentsEnum.LOAN_2A) {
      this.addLoanFields();
    }
  },
  methods: {
    toggleSelected(customField) {
      this.$set(customField, 'selected', !customField.selected);
    },
    setDeleteMode(deleteMode) {
      this.customFields.forEach((item) => {
        if (item.selected === true) {
          item.selected = false;
        }
      });
      this.deleteMode = deleteMode;
    },
    addCustomField(data) {
      if (!this.customFieldExists(data.name)) {
        this.addFunction({
          type: data.type,
          name: data.name,
          value: data.value,
        });
        this.isOpenAddCustomField = false;
      }
    },
    deleteSelectedFields() {
      this.deleteFunction({
        customFields: this.customFields,
      });
    },
    openAddCustomFieldModal() {
      this.isOpenAddCustomField = true;
    },
    closeCustomFieldModal() {
      this.isOpenAddCustomField = false;
    },
    customFieldExists(name) {
      return this.customFields.filter(customField => customField.name === name).length !== 0;
    },
    addYieldTokenFields() {
      this.addCustomField({ type: 'date', name: 'firstPaybackAt', value: undefined });
    },
    addFinancingTokenFields() {
      this.addCustomField({ type: 'float', name: 'returnOnEquityRateOverall', value: undefined });
    },
    addLoanFields() {
      this.addCustomField({ type: 'float', name: 'delayInterestRate', value: undefined });
      this.addCustomField({ type: 'date', name: 'delayStartDate', value: undefined });
      this.addCustomField({ type: 'date', name: 'delayEndDate', value: undefined });
      this.addCustomField({ type: 'date', name: 'payback', value: undefined });
    },
    isFieldDisabled(customField) {
      if (!customField) {
        return false;
      }

      const disabledFieldNames = [
        'smart_contract_address',
        'vault_asset_id',
        'mangopay_user_id',
        'origin',
        'issuer',
        'paybackIntervalInMonth',
        'runningTimeInMonths',
        'interestRate',
      ];

      return disabledFieldNames.includes(customField.name);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/financialProducts/CustomFieldsExpansionPanel.vue